import { popularCategories } from '@/mocks/categories';

export default function CategoryGridA() {
  return (
    <section id="categories" className="w-full bg-background-50 py-16 md:py-20 px-4 md:px-8">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-6 mb-12">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight">
            Esplora le
            <br />
            Categorie Prodotti
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-md leading-relaxed md:pt-3">
            Scopri tutte le categorie disponibili su Itaobuy Spreadsheet. Ogni categoria contiene prodotti selezionati e aggiornati per aiutarti a trovare esattamente ciò che cerchi.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {popularCategories.map((cat, index) => (
            <a
              key={cat.id}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group rounded-2xl bg-background-100 overflow-hidden transition-all duration-300 hover:scale-[1.02] cursor-pointer"
              style={{ animation: `fadeInUp 0.7s ease-out ${index * 0.1}s forwards`, opacity: 0 }}
            >
              <div className="h-52 md:h-60 overflow-hidden">
                <img
                  src={cat.imageUrl}
                  alt={'Itaobuy Spreadsheet ' + cat.nameIt}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 md:p-6">
                <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-950 mb-1">
                  {cat.nameIt}
                </h3>
                <p className="text-sm text-foreground-500 flex items-center gap-1.5">
                  <span>{cat.name}</span>
                  <i className="ri-arrow-right-up-line text-xs"></i>
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}